import React from 'react';
import { lazy } from 'react';
import Loadable from '../view-components/Loadable';
import Front from '../views/landing/Front';
import NotFound404 from '../views/NotFound404';

// render - login
const AuthLogin = Loadable(lazy(() => import('../views/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('../views/authentication/Register')));
const ContactUs = Loadable(lazy(() => import('../views/contact/contactUs')));
const TermsAndConditions = Loadable(lazy(() => import('../views/legal/TermsAndConditions')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: <Front />
        },
        {
            path: 'login',
            element: <AuthLogin />
        },
        {
            path: 'register',
            element: <AuthRegister />
        },
        {
            path: 'contact_us',
            element: <ContactUs />
        },
        {
            path: 'terms',
            element: <TermsAndConditions />
        },
        {
            path: '/',
            element: <Front />
        }
    ]
};

// Note: The catch-all (*) for 404 is handled in AdminRoutes
// Authenticated users will see 404 there, unauthenticated users will be redirected to login

export default LoginRoutes;
